export function isPositiveFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}

export function isOptionalString(value: unknown): value is string | undefined {
  return value === undefined || typeof value === "string";
}

export function isOptionalPositiveFiniteNumber(
  value: unknown,
): value is number | undefined {
  return value === undefined || isPositiveFiniteNumber(value);
}
